var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3021_4648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.22917 5.34686C1.32083 5.46603 6.49083 12.066 6.49083 12.066V17.5752C6.49083 18.0794 6.90333 18.4919 7.41667 18.4919H9.25917C9.76333 18.4919 10.185 18.0794 10.185 17.5752V12.0569C10.185 12.0569 15.2175 5.62186 15.4558 5.32853C15.6942 5.0352 15.6667 4.74186 15.6667 4.74186C15.6667 4.2377 15.2542 3.8252 14.7408 3.8252H1.92583C1.36667 3.8252 1 4.2652 1 4.74186C1 4.9252 1.055 5.1452 1.22917 5.34686Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0672 10.7378C14.3483 10.4566 14.8041 10.4566 15.0852 10.7378L21.3124 16.965C21.5935 17.2461 21.5935 17.7019 21.3124 17.983C21.0313 18.2641 20.5755 18.2641 20.2944 17.983L14.0672 11.7557C13.7861 11.4746 13.7861 11.0189 14.0672 10.7378Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3172 10.7378C21.5983 11.0189 21.5983 11.4747 21.3172 11.7558L15.0899 17.9831C14.8088 18.2642 14.3531 18.2642 14.072 17.9831C13.7908 17.7019 13.7908 17.2462 14.072 16.9651L20.2992 10.7378C20.5803 10.4567 21.0361 10.4567 21.3172 10.7378Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3021_4648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.158447)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilter);
export default __webpack_public_path__ + "static/media/clear_filter.4bbabda832603ee821d786811d61086c.svg";
export { ForwardRef as ReactComponent };